import { createComponentStore } from './createComponentStore';
export const useDecisionPositionsGridActionsComponentStore = createComponentStore('decisionPositionsGridActionsComponentStore');
